import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { BusyIndicatorMessageManager } from '../../../Busy-Indicator';
import { TaxFeedLogRepository } from '../taxFeedLog.repository';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { TaxFeedLogDetailsGridComponent } from './taxFeedLogDetailsGrid.component';

export interface TaxFeedLogDetailsParams {
    summaryLogId: number;
}

@Component({
    selector: 'tax-feed-log-details-modal',
    templateUrl: './taxFeedLogDetailsModal.component.html',
    styleUrls: ['./taxFeedLogDetailsModal.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None
})
export class TaxFeedLogDetailsModalComponent implements OnInit, IWeissmanModalComponent<TaxFeedLogDetailsParams, void> {
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _taxFeedLogRepository: TaxFeedLogRepository) {
    }

    @ViewChild('taxFeedLogDetailsGrid') taxFeedLogDetailsGrid: TaxFeedLogDetailsGridComponent;

    busyIndicatorMessageManager: BusyIndicatorMessageManager<string> = new BusyIndicatorMessageManager<string>();

    params: TaxFeedLogDetailsParams;
    result: void;

    taxFeedDiagnosticsDetail: Core.TaxFeedDiagnosticsDetailModel;

    async ngOnInit(): Promise<void> {
        const busyMsgId = 'loading';
        this.busyIndicatorMessageManager.add('Loading Tax Feed Log Details', busyMsgId);

        const searchParams: Core.TaxFeedDiagnosticsDetailSearchModel = {
            summaryLogId: this.params.summaryLogId
        };

        try {
            this.taxFeedDiagnosticsDetail = await lastValueFrom(this._taxFeedLogRepository.getDetail(searchParams));
        } finally {
            this.busyIndicatorMessageManager.remove(busyMsgId);
        }
    }

    cancel(): void {
        this._bsModalRef.hide();
    }
}
